import { cva, type VariantProps } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex items-center justify-center gap-x-1 rounded-full px-2 py-1 text-xs font-normal leading-tight ring-1 ring-inset',
  {
    variants: {
      color: {
        gray: 'bg-gray-50 text-gray-700 ring-gray-500/20 dark:bg-gray-400/10 dark:text-gray-300 dark:ring-gray-300/30',
        red: 'bg-red-50 text-red-700 ring-red-500/20 dark:bg-red-400/10 dark:text-red-400 dark:ring-red-400/30',
        orange:
          'bg-orange-50 text-orange-800 ring-orange-500/20 dark:bg-orange-400/10 dark:text-orange-400 dark:ring-orange-400/30',
        green:
          'bg-green-50 text-green-800 ring-green-500/20 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/30',
        blue: 'bg-blue-50 text-blue-700 ring-blue-500/20 dark:bg-blue-400/10 dark:text-blue-200 dark:ring-blue-300/30',
        cyan: 'bg-cyan-50 text-cyan-700 ring-cyan-500/20 dark:bg-cyan-400/10 dark:text-cyan-400 dark:ring-cyan-400/30',
        violet:
          'bg-violet-50 text-violet-700 ring-violet-500/20 dark:bg-violet-400/10 dark:text-violet-300 dark:ring-violet-300/30',
      },
      background: {
        transparent: '',
        solid: 'text-white dark:text-black',
        none: 'bg-transparent p-0 ring-0 dark:bg-transparent',
      },
    },
    compoundVariants: [
      {
        color: 'gray',
        background: 'solid',
        class: 'bg-gray-600 dark:bg-gray-400',
      },
      {
        color: 'red',
        background: 'solid',
        class: 'bg-red-600 dark:bg-red-500',
      },
      {
        color: 'orange',
        background: 'solid',
        class: 'bg-orange-600 dark:bg-orange-500',
      },
      {
        color: 'green',
        background: 'solid',
        class: 'bg-green-600 dark:bg-green-500',
      },
      {
        color: 'blue',
        background: 'solid',
        class: 'bg-blue-600 dark:bg-blue-400',
      },
      {
        color: 'cyan',
        background: 'solid',
        class: 'bg-cyan-600 dark:bg-cyan-500',
      },
      {
        color: 'violet',
        background: 'solid',
        class: 'bg-violet-600 dark:bg-violet-500',
      },
    ],
    defaultVariants: {
      color: 'gray',
      background: 'transparent',
    },
  },
);

export const badgeRemoveButtonVariants = cva(
  'group relative flex h-3.5 w-3.5 appearance-none items-center justify-center rounded-full p-0',
  {
    variants: {
      color: {
        gray: '!text-gray-700/50 hover:bg-gray-400/20 group-hover:!text-gray-600/75 dark:!text-gray-300/50 dark:group-hover:!text-gray-300/75',
        red: '!text-red-600/50 hover:bg-red-400/20 group-hover:!text-red-600/75 dark:!text-red-400/60 dark:group-hover:!text-red-400/75',
        orange:
          '!text-orange-600/50 hover:bg-orange-500/20 group-hover:!text-orange-600/75 dark:!text-orange-400/50 dark:group-hover:!text-orange-400/75',
        green:
          '!text-green-600/50 hover:bg-green-500/20 group-hover:!text-green-600/75 dark:!text-green-400/50 dark:group-hover:!text-green-400/75',
        blue: '!text-blue-600/50 hover:bg-blue-300/20 group-hover:!text-blue-600/75 dark:!text-blue-200/50 dark:group-hover:!text-blue-200/75',
        cyan: '!text-cyan-600/50 hover:bg-cyan-400/20 group-hover:!text-cyan-600/75 dark:!text-cyan-400/50 dark:group-hover:!text-cyan-400/75',
        violet:
          '!text-violet-600/50 hover:bg-violet-400/20 group-hover:!text-violet-600/75 dark:!text-violet-300/50 dark:group-hover:!text-violet-300/75',
      },
    },
    defaultVariants: {
      color: 'gray',
    },
  },
);

export type KaBadgeVariants = VariantProps<typeof badgeVariants>;
export type KaBadgeRemoveButtonVariants = VariantProps<typeof badgeRemoveButtonVariants>;
